/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Open_Rounds_WarningInputs */



/**
* | output |
* | --- |
* | "Open-rounds events aren't reported to VEKN and don't count for rankings." |
*
* @param {Tfield_Open_Rounds_WarningInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_open_rounds_warning = /** @type {((inputs?: Tfield_Open_Rounds_WarningInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Open_Rounds_WarningInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les tournois en rondes ouvertes ne sont pas déclarés à la VEKN et ne comptent pas pour le classement.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los torneos de rondas abiertas no se reportan a la VEKN y no cuentan para el ranking.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Torneios de rodadas abertas não são reportados à VEKN e não contam para o ranking.")
	if (locale === "it") return /** @type {LocalizedString} */ ("I tornei a round aperti non sono comunicati alla VEKN e non contano per il ranking.")
	return /** @type {LocalizedString} */ ("Open-rounds events aren't reported to VEKN and don't count for rankings.")
});